import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom";
//import { withTranslation } from "react-i18next"
import { Formik, FieldArray,Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { capitalize, isEmpty, map, size } from "lodash";
import {
  Row,
  Col,
  FormGroup,
  Label,
  InputGroup,
  Table
} from "reactstrap"
import { Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import classnames from "classnames"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { withTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from "axios"
import { addLeadAPP , getListLeadTab} from "../../../store/leads/actions"
import SaveButton from "components/buttons/save";
import Moment from "react-moment";
import CurrencyFormat from "react-currency-format";
class LeadListing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mlsFields: [{ mlsId: "", mlsLink: "" }]
      
    }
    this.handelValidListLead = this.handelValidListLead.bind(this)
  }  

 

  handelValidListLead(value) {
   
    
  }
  componentDidMount(){
    const { match: { params }, lead, onGetListLeadTab } = this.props;
    
   
      
      onGetListLeadTab(params.id);
   
  }
  
  render() {
    
   const { listings }  = this.props;
  
    return (
      <React.Fragment>
        {/* Your other components */}

        <div className="h4 card-title">Listing</div>
       

        <div className="table-rep-plugin">
                          <div
                            className="table-responsive mb-0"
                            data-pattern="priority-columns"
                          >
                            <Table
                              id="tech-companies-1"
                              className="table table-striped table-bordered"
                            >
                              <Thead>
                                <Tr>
                                  <Th>{this.props.t("Date")}</Th>
                                  <Th>{this.props.t("Mls")}</Th>
                                  <Th>{this.props.t("Price")}</Th>
                                  <Th>{this.props.t("Bedroom")}</Th>
                                  <Th>{this.props.t("Bathroom")}</Th>
                                  <Th>{this.props.t("City")}</Th>
                                </Tr>
                              </Thead>
                             <Tbody>
                              {listings && listings.length > 0 ? (
                                listings.map((addListing, index) => (
                                  <tr key={index}>
                                    <td><Moment format='DD MMM, YYYY'>{addListing.listingDate}</Moment></td>
                                    <td>
                                      <a target="_blank" rel="noreferrer" href={addListing.mlsurl}>
                                        {addListing.mlsId} <i className="bx bx-link-external"></i>
                                      </a>
                                    </td>
                                    <td><CurrencyFormat value={addListing.listedPrice} displayType="text" thousandSeparator prefix="$" /></td>
                                    <td>{addListing.listingBedroom}</td>
                                    <td>{addListing.listingBathroom}</td>
                                    <td>{addListing.listingCity}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">No listings available</td>
                                </tr>
                              )}
                            </Tbody>
                            </Table>
                          </div>
                        </div>
      </React.Fragment>
    );
  }
}
LeadListing.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  onGetListLeadTab: PropTypes.func,
  history: PropTypes.object,
  lead:PropTypes.object,
  listings: PropTypes.array,


}
const mapStateToProps = ({ leads }) => (
  {
    listings: leads.listings
    
  })
const mapDispatchToProps = dispatch => ({
  onGetListLeadTab: leadId => dispatch(getListLeadTab(leadId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(LeadListing)));

